import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import serviceImg from "../../assets/packageservice.webp";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./servicepackage.css";

const accordionData = [
  {
    title: "Priority Replacement of Parts",
    content:
      "We ensure that all replaceable parts are provided on priority, with no upfront payment required.",
    color: "primary",
    icon: "bi-tools", // icon name from Bootstrap Icons
  },
  {
    title: "No Advance Payment for Support Visits",
    content:
      "For every support visit, there is no need to provide a deposit or advance payment.",
    color: "success",
    icon: "bi-cash-coin",
  },
  {
    title: "Annual Preventive Maintenance",
    content:
      "Our AMC contract includes one free preventive maintenance service per year to keep your equipment running smoothly.",
    color: "warning",
    icon: "bi-calendar-check",
  },
  {
    title: "24x7 Support Coverage",
    content:
      "Our team is available 24/7, ensuring prompt support whenever you need assistance.",
    color: "danger",
    icon: "bi-headset",
  },
];

const ServicePackage = () => {
  return (
    <div className="py-4" style={{ overflow: "hidden" }}>
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            <h2 className="title-font pb-4" data-aos="fade-up">
              {"Comprehensive Service Package".split(" ").map((word, index) => (
                <span
                  key={index}
                  className="title-word"
                  style={{ animationDelay: `${index * 0.2}s` }}
                >
                  {word}&nbsp;
                </span>
              ))}
            </h2>

            <Accordion className="custom-accordion" flush>
              {accordionData.map((item, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={index}
                  className="accordion-item"
                  data-aos="zoom-out"
                >
                  <Accordion.Header>
                    <div className="d-flex align-items-center gap-3">
                      <div
                        className="shadow rounded-circle p-3 header-accordion"
                        style={{ backgroundColor: "#d8e5ee" }}
                      >
                        <i
                          className={`bi ${item.icon} fs-4 d-none d-lg-block`}
                        ></i>
                      </div>
                      <span className="accordion-text-title">{item.title}</span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body className="accordion-body">
                    {item.content}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
          <Col
            xs={12}
            md={6}
            className="mb-4 mb-md-0 text-center d-none d-lg-block"
          >
            <div
              className="service-image-wrapper rounded-4"
              style={{ border: "7px solid black" }}
            >
              <img
                src={serviceImg}
                alt="Service Package"
                className="rounded-3 w-100 h-100"
                data-aos="zoom-in"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ServicePackage;
